/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sales_Order_Uncovered_Not_SettleableInputs */

const en_error_sales_order_uncovered_not_settleable = /** @type {(inputs: Error_Sales_Order_Uncovered_Not_SettleableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This order has no units left without cover: there is nothing to settle.`)
};

/**
* | output |
* | --- |
* | "This order has no units left without cover: there is nothing to settle." |
*
* @param {Error_Sales_Order_Uncovered_Not_SettleableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_sales_order_uncovered_not_settleable = /** @type {((inputs?: Error_Sales_Order_Uncovered_Not_SettleableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sales_Order_Uncovered_Not_SettleableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_sales_order_uncovered_not_settleable(inputs)
});